import React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./style.css";
import { ReactComponent as StockGroup } from "assets/img/StockGroup.svg";
import { ReactComponent as CahierGroup } from "assets/img/CahierGroup.svg";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const ReportDialog = ({ handleClose, open, children, handleNavigate }) => {
  return (
    <BootstrapDialog
      className="popupbox"
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
        Choisissez un type de rapport
      </BootstrapDialogTitle>
      <ul>
        <li onClick={() => handleNavigate("/stock-report")}>
          <StockGroup />
         Les rapports de Fiche de Stock <ArrowForwardIosIcon />
        </li>
        <li onClick={() => handleNavigate("/cahier-report")}>
          <CahierGroup />
         Les rapports de Journal de caisse<ArrowForwardIosIcon />
        </li>
      </ul>
    </BootstrapDialog>
  );
};

export default ReportDialog;
